import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { GalleryComponent } from 'src/app/shared/components/gallery/gallery.component';

@Component({
    selector: 'app-short-page',
    templateUrl: './short-page.component.html',
    styleUrls: ['./short-page.component.scss'],
    standalone: true,
    imports: [GalleryComponent]
})
export class ShortPageComponent implements OnInit {
  constructor(public appService: AppService, private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.appService.isHeaderDark = true;
    this.ref.detectChanges();
  }

  cpaClicked(): void {
    window.open('mailto:' + this.appService.email, '_blank');
  }
}
